module.exports = __webpack_public_path__ + "static/media/aSNX-logo.c9de216b.png";